import { CharComp } from '@/components/CharComp'
import { getUserCenterPageRoute, PageRoutes, UserCenterRoutes } from '@/constants/PageRoutes'
import { ButtonType, useSpotOrdererSell } from '@/hooks/use-spot-orderer-sell'
import classNames from 'classnames'
import { ElForm, ElFormItem } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useBaseInfoStore, useKlineStore, useUserInfoStore } from 'store'
import { CustomButton, HocElSlider, InputView, PrimaryPlusIcon } from 'ui-components'
import { DefineComponentProps } from 'utils'
import '../styles/orderer-buy-sell-layout.scss'
interface OrdererSellProps {
  activeTab?: string
  onClose?: () => void
}

export const OrdererSell = defineComponent<OrdererSellProps>({
  props: DefineComponentProps<OrdererSellProps>(['activeTab', 'onClose']),
  setup(props) {
    const { t } = useI18n()
    const ordererSell = useSpotOrdererSell()
    const userStore = useUserInfoStore()
    const klineStore = useKlineStore()
    const router = useRouter()
    const formatTooltip = (value: number) => {
      return `${value}%`
    }
    const baseInfoStore = useBaseInfoStore()

    const gotoLogin = () => {
      router.push({
        path: PageRoutes.Login,
        query: {
          redirect: window.decodeURIComponent(router.currentRoute.value.path),
        },
      })
    }

    const gotoRegister = () => {
      router.push({
        path: PageRoutes.Register,
        query: {
          entry: 'spot_trade',
        },
      })
    }

    const onRecharge = () => {
      const data = baseInfoStore.getCoinStaticItemDataBySymbolId(klineStore.currentSymbolId!)
      router.push({
        path: getUserCenterPageRoute(UserCenterRoutes.Recharge),
        query: {
          itemId: data?.coinFrom,
        },
      })
    }

    watch(
      () => props.activeTab,
      (val) => {
        if (val !== 'sell') {
          ordererSell.onClear()
        }
      },
    )

    return () => (
      <div class="orderer-buy-sell-layout sell">
        {/* 按钮类型 */}
        <div class="button-type">
          {ordererSell.buttonTypeList.map((item) => (
            <div
              class={classNames('button-type-item', {
                active: ordererSell.buttonType.value === item.value,
              })}
              onClick={() => ordererSell.handleButtonTypeChange(item.value)}
            >
              {t(item.label)}
            </div>
          ))}
        </div>
        <ElForm labelPosition="top">
          <ElFormItem label={t('价格')}>
            <InputView
              height={40}
              radius={6}
              v-model={ordererSell.sellPrice.value}
              disabled={ordererSell.buttonType.value === ButtonType.Market}
              isFloatNumber
              suffixIcon={() => 'USDT'}
              maxDecimalLength={klineStore.coinToPrecision}
            />
          </ElFormItem>
          <ElFormItem label={t('数量')}>
            <InputView
              height={40}
              radius={6}
              placeholder={t('数量')}
              v-model={ordererSell.sellAmount.value}
              onFocus={ordererSell.onSellAmountFocus}
              onBlur={ordererSell.onSellAmountBlur}
              onInput={ordererSell.onSellAmountInput}
              isFloatNumber
              suffixIcon={() => ordererSell.fromSpotSymbolName.value}
              maxDecimalLength={klineStore.coinFromPrecision}
            />
          </ElFormItem>
          <div class="px-8">
            <HocElSlider
              v-model={ordererSell.slider.value}
              marks={ordererSell.sliderMarks.value}
              formatTooltip={formatTooltip}
              onInput={(value) => ordererSell.onSliderInput(value as number)}
            />
          </div>
          {/* 卖出金额 */}
          <div class="trade-amount">
            <span>{t('卖出金额')}</span>
            <span class="trade-amount-value">
              <CharComp>{ordererSell.tradeAmount.value.formatNumberWithCommas() || '--'} USDT</CharComp>
            </span>
          </div>
          {/* 可用 */}
          <div class="available">
            <span>{t('可用')}:</span>
            <span class="available-amount">
              <CharComp>
                {ordererSell.availableAssets.value?.formatNumberWithCommas().decimalPadZero(klineStore.coinFromPrecision) || '--'} {ordererSell.fromSpotSymbolName.value}
              </CharComp>
            </span>
            {userStore.isLogin && <PrimaryPlusIcon onClick={onRecharge} stroke="var(--colors-bg-icon-primary)" />}
          </div>
        </ElForm>

        {/* 登录显示登录注册 */}
        {!userStore.isLogin && (
          <div class="login-register">
            <CustomButton type={'primary'} onClick={gotoRegister}>
              {t('立即注册')}
            </CustomButton>
            <CustomButton type={'aux'} onClick={gotoLogin}>
              {t('登录')}
            </CustomButton>
          </div>
        )}
        {userStore.isLogin && (
          <CustomButton
            class="btn sell"
            type={'primary'}
            primaryColor="var(--colors-down)"
            loading={ordererSell.isLoading.value}
            onClick={() =>
              ordererSell.orderSell(() => {
                props.onClose?.()
                ordererSell.sellAmount.value = ''
              })
            }
          >
            <span>{t('卖出')}</span>
            <span>{ordererSell.fromSpotSymbolName.value}</span>
          </CustomButton>
        )}
      </div>
    )
  },
})
